import { COLUMNS, pad } from '@bingo/shared';
import { LetterBall } from './Ball.js';

/**
 * Painel B-I-N-G-O, 5 colunas de 15 números.
 * Estrutura idêntica ao protótipo: `.board > .col > .ball.letter + .cells > .cell`.
 */

interface BoardProps {
  drawn: readonly number[];
  /** A última bola pulsa com contorno branco, como no protótipo. */
  lastBall: number | null;
  /** Modo globo físico no /controle: clicar na casa informa o número. */
  onPick?: (ball: number) => void;
}

export function Board({ drawn, lastBall, onPick }: BoardProps) {
  const drawnSet = new Set(drawn);

  return (
    <section className="board" id="board" aria-label="Painel de números sorteados">
      {COLUMNS.map((column) => (
        <div
          key={column.letter}
          className="col"
          style={{ '--c': column.color } as React.CSSProperties}
        >
          <LetterBall letter={column.letter} color={column.color} />
          <div className="cells">
            {Array.from({ length: 15 }, (_, index) => {
              const ball = column.min + index;
              const on = drawnSet.has(ball);

              return (
                <button
                  key={ball}
                  type="button"
                  className={['cell', on ? 'on' : '', ball === lastBall ? 'last' : '']
                    .filter(Boolean)
                    .join(' ')}
                  id={`cell-${ball}`}
                  aria-label={`${column.letter} ${ball}`}
                  style={{ '--c': column.color } as React.CSSProperties}
                  onClick={onPick && !on ? () => onPick(ball) : undefined}
                  // No telão as casas não são interativas: o painel é só
                  // exibição, e botão desabilitado perderia o contraste.
                  tabIndex={onPick ? 0 : -1}
                >
                  {pad(ball)}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
